<template>
  <select ref="selectNode">
    <option
      v-for="optionObject in computedOptions"
      :key="optionObject.id"
      :value="optionObject.id"
    >
      {{ optionObject.text }}
    </option>
  </select>
  <adivare-alert
    v-if="showError"
    class="mt-1"
    :messages="errorMessage"
    size="xs"
    show-icon
  />
</template>

<script>
import AdivareAlert from '../../../components/alert';
import { mapGetters } from 'vuex';

export default {
  name: "adivare-select-two",
  components: {
    AdivareAlert,
  },
  emits: [
    'update:modelValue',
  ],
  props: {
    propertyName: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: () => this.$t('messages_nl.global.required'),
      required: false,
    },
    modelValue: {
      validator(value) {
        const valueType = typeof value;
        return 'string' === valueType || 'number' === valueType;
      },
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      selectValue: null,
    }
  },
  computed: {
    ...mapGetters([
      'showErrors',
      'getFormFieldValidityState',
      'getCancellationOptions',
    ]),
    selectNode() {
      return $(this.$refs.selectNode);
    },
    computedOptions() {
      return this.getCancellationOptions;
    },
    showError() {
      return (
        true === this.showErrors
        && false === this.getFormFieldValidityState(this.propertyName)
      );
    },
  },
  mounted() {
    this.selectTwo();
  },
  unmounted() {
    this.selectNode.off().select2('destroy');
  },
  watch: {
    selectValue(value) {
      this.$emit('update:modelValue', value);
    },
  },
  methods: {
    selectTwo() {
      const componentScope = this;
      this.selectNode.select2(
        {
          data: this.computedOptions,
          placeholder: componentScope.placeholder,
          language: {
            noResults: () => {
              return this.$t('messages_nl.partials.letter.select2.noResults');
            }
          },
        }
      ).val(this.value)
       .trigger('change')
       .on('change', function() {
         componentScope.$store.commit('updateFormFieldValidity', {
           name: componentScope.propertyName,
           valid: true,
         });
         componentScope.selectValue = this.value;
        }
      );
    }
  }
}
</script>
